import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=f03b23d6&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=js&"
export * from "./JobDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03b23d6",
  null
  
)

export default component.exports